import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import { Alert, Button, Card, Col, Container, Form, FormGroup, ListGroup, ListGroupItem, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ErrorMessage from '../../components/common/ErrorMessage';
import { useForm } from 'react-hook-form';
import { useisLoading } from '../../hook/useisLoading';
import { useSelector } from 'react-redux';
import types from '../../types/types';
import Loading from '../../components/common/Loading';
import { AccountsAPI, BusinessDBAPI, AccountUserAPI, ApplicationsAPI } from '../../components/apis';
import InputField from '../../components/common/InputField';
import { ButtonEdit } from '../../components/common/ButtonEdit';
import { ButtonView } from '../../components/common/ButtonView';
import history from '../../history';
import { ButtonAdd } from '../../components/common/ButtonAdd';
import { confirmAlert } from 'react-confirm-alert';
import { ButtonDelete } from '../../components/common/ButtonDelete';
import { NoData } from '../../components/common/NoData';

export const Account = (props, context) => {
    
    console.log("Enter into Account.js");

    const id = props.id;
    
    const { user, token } = useSelector(state => state.user);

    const [accountsAPI, setAccountsAPI] = useState(null);

    const [accountUserAPI, setAccountUserAPI] = useState(null);
    const [businessDBAPI, setBusinessDBAPI] = useState(null);
    const [applicationsAPI, setApplicationsAPI] = useState(null);
    
    const [backendError, setBackendError] = useState(null);

    // Variable to show/hide "spinner" while loading page.
    const { isLoading, showSpinner, hideSpinner } = useisLoading(true);
   
    const [businessdb, setBusinessdb] = useState(null);

    const [account, setAccount] = useState(null);    
    const [map, setMap] = useState(null);
    const [marker, setMarker] = useState(null);

    const [applications, setApplications] = useState(null);
    const [users, setUsers] = useState(null);

    // Stander useForm of react-hook-form Library
    const { register, handleSubmit, getValues, setValue } = useForm({
        defaultValues: {
            // User default attribute for create new entity
    
            // backendError is used to set back-end-error message when service has fail (to show to the user)
            backendError: null,
            // onSubmitOk is used to control if onSubmit acction was success.
            onSubmitOk: null,
        }
    });
    
    
    // Load objetcts
    useEffect(() => {
    
        if (token) {
            
            setAccountsAPI(new AccountsAPI(token));
            setAccountUserAPI(new AccountUserAPI(token, props.id));
            setBusinessDBAPI(new BusinessDBAPI(token, props.id));
            setApplicationsAPI(new ApplicationsAPI(token, props.id));
            
            hideSpinner();
        }

    }, [token])


    // Loading account data
    useEffect(() => {
        if (accountsAPI) {
            accountsAPI.get(props.id).then(account => {
                setAccount(account);
                setValue("email", account.email);
                setValue("phone_number", account.phone_number);
                setValue("enabled", account.enabled);
            }).catch(err => {
                setBackendError(err);
            });
        }
    }, [accountsAPI]);


    // Loading account's users
    useEffect(() => {
        if (accountUserAPI) {
            accountUserAPI.getAll().then(users => {
                setUsers(users);
            }).catch(err => {
                setBackendError(err);
            });
        }
    }, [accountUserAPI]);


    // Loading business databases
    useEffect(() => {
        if (businessDBAPI) {
            businessDBAPI.getAll().then(dbs => {
                setBusinessdb(dbs);
            }).catch(err => {
                setBackendError(err);
            });
        }
    }, [businessDBAPI]);
    
    
    // Loading business applications
    useEffect(() => {        
        if (applicationsAPI){
            applicationsAPI.getAll(props.id).then(applications => {
                setApplications(applications);          
            }).catch(err => {
                setBackendError(err);
            });
        }
    }, [applicationsAPI])
    

    const handleChange = (field, event) => {
        setValue([field], event.target.value);
    }
   

    if (isLoading || !account) {
        return (
            <Loading />  
        )
    } else {
        return ( <>
            {/* If "backendError" has value, it shows to the user */}
            <ErrorMessage message={getValues().backendError}/>
            <Container fluid className="main-content-container px-4">
                <br/>
                <Row>
                    <Col lg="4">
                        <Card className="mb-4 pt-3">
                        <Card.Header className="border-bottom text-center">
                            <div className="mb-3 mx-auto">
                                <i className="material-icons blue-text" style={{fontSize: "78px"}}>verified_user</i>
                            </div>
                            <h4 className="mb-0">{account.name}</h4>
                            <span className="text-muted d-block mb-2">{account.business_id}</span>
                            {(user.roles[0].id === types.USER_ROOT_ID) ? (
                                <ButtonEdit to={'/accounts/edit/'+ account.id} />
                            ) : ('')}
                        </Card.Header>
                        <ListGroup>
                            <ListGroupItem className="p-4">
                                <i className="material-icons orange-text">location_on</i> {account.address}
                            </ListGroupItem>
                        </ListGroup>
                        </Card>
                    </Col>
                    <Col lg="8">
                        <Card className="mb-4">
                        <Card.Header className="border-bottom pt-2">
                            <h6 className="m-0" style={{ float: "left" }}>{context.t('Details')}</h6>
                            <i className="material-icons mx-3" style={{ float: "right", cursor: "pointer", fontSize: "20px" }} onClick={e => { history.goBack() }}>arrow_back</i>
                        </Card.Header>
                        <Card.Body className="pt-1">
                            <Row className="border-bottom py-2 bg-light">
                                <Col sm="6" className="mb-2 mb-sm-0" style={{ paddingTop: "7px" }}>
                                    <b> <i className="material-icons">access_time</i> {account.created_at}</b>
                                </Col>
            
                            </Row>
                            <br />
                            <Row>
                                <Col>
                                    <Form>
                                    {/* <Form.Group className="mb-3" controlId="formBasicCheckbox">
                                        <Form.Check type="checkbox" checked={ register("enabled")}
                                        onChange={e => { handleChange('enabled', e) }}
                                        label={context.t('Enabled')} />
                                    </Form.Group> */}
                                    <FormGroup>
                                        <InputField label= { context.t('Email') } name="email" disabled={true} useFormRegister= { register("email") } />
                                        <InputField label= { context.t('Phone') } name="phone_number" disabled={true} useFormRegister= { register("phone_number") } />
                                    </FormGroup>
                                    </Form>
                                </Col>
                            </Row>
                        </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col lg="4">
                        <Card className="mb-4 pt-3">
                        <Card.Header className="border-bottom text-center">
                            <div className="mb-3 mx-auto">
                            <i className="material-icons" style={{fontSize: "34px"}}>account_circle</i>
                            </div>
                            <h6 className="mb-0">{context.t('Users')}</h6>
                            <br/>
    
                            {(user.roles[0].id !== types.USER_BASIC_ID) ? (
                                
                                <ButtonView to={'/users'} />
                            ) : (
                            ''
                            )}
                        </Card.Header>
                        <ListGroup>
                            <ListGroupItem className="p-4">
                            <div className="stats-small__data text-center" style={{ marginLeft: "25%"}}>
                                <span className="stats-small__label text-uppercase">{context.t('Amount Of')} {context.t('Users')}</span>
                                <h6 className="stats-small__value count my-3">{ (users)?users.length:0}</h6>
                            </div>
                            </ListGroupItem>
                        </ListGroup>
                        </Card>
                    </Col>
                    <Col lg="4">
                        <Card className="mb-4 pt-3">
                        <Card.Header className="border-bottom text-center">
                            <div className="mb-3 mx-auto">
                                <i className="material-icons" style={{fontSize: "34px"}}>storage</i>
                            </div>
                            <h6 className="mb-0">Business DB</h6>
                            <br/>
                            {(user.roles[0].id === types.USER_ROOT_ID || user.roles[0].id === types.USER_ADMIN_ID) ? (
                                <Row>
                                    <Col className="d-flex justify-content-around">
                                        <ButtonAdd to={'/accounts/'+id+'/bussinessdb/new'} iconSize="md-24" />
                                    </Col>
                                </Row>
                            ) : (
                                ''
                            )}
                        </Card.Header>
                        <ListGroup>
                            <ListGroupItem className="p-4">
                            { businessdb && businessdb.length > 0 ? businessdb && businessdb.map(db => {
                                return (
                                    <Card key={db.id} className="card-post mb-2">
                                        <Card.Body className="d-flex" style={{padding: "16px"}}>
                                            <div className="card-post__author d-flex">
                                            <i className="material-icons md-24" style={{float: "left"}}>storage</i>
                                            <div className="d-flex flex-column justify-content-center ml-3">
                                                <span className="card-post__author-name">{db.name}</span>
                                                <small className="text-muted">{db.database_host}:{db.database_port}</small>
                                            </div>
                                            </div>
                                            {user.roles[0].id === types.USER_ROOT_ID || user.roles[0].id === types.USER_ADMIN_ID ? (
                                                <div className="my-auto ml-auto d-flex flex-nowrap">
                                                    <ButtonView to={'/accounts/'+id+'/bussinessdb/edit/'+db.id} />
                                                    {/* <ButtonDelete onClick={e => { removeBussinessDB(e, db.id, db.name)} } /> */}
                                                </div>
                                            ) : ('')}
                                        </Card.Body>
                                    </Card>
                                )
                            }) :
                                <NoData/>
                            }
                            </ListGroupItem>
                        </ListGroup>
                        </Card>
                    </Col>
                    <Col lg="4">
                        <Card className="mb-4 pt-3">
                        <Card.Header className="border-bottom text-center">
                            <div className="mb-3 mx-auto">
                            <i className="material-icons" style={{fontSize: "34px"}}>apps</i>
                            </div>
                            <h6 className="mb-0">{context.t('Apps')}</h6>
                            <br/>
                            {user.roles[0].id === types.USER_ROOT_ID || user.roles[0].id === types.USER_ADMIN_ID? (
                                <div className="my-auto ml-auto">
                                    <ButtonAdd to={'/accounts/'+id+'/apps/new'} iconSize="md-24" />
                                </div>
                            ) : (
                            ''
                            )}
    
                        </Card.Header>
                        <ListGroup>
                            <ListGroupItem className="p-4">
                            { applications && applications.length > 0 ? applications && applications.map(app => {

                                    return (app.deleted_at === null)?( // Render all application that were't deleted
                                        <Card key={app.id} className="card-post mb-2">
    
                                        <Card.Body className="d-flex" style={{padding: "16px"}}>
                                            <div className="card-post__author d-flex">
                                            <i className="material-icons md-24" style={{float: "left"}}>apps</i>
                                            <div className="d-flex flex-column justify-content-center ml-3">
                                                <span className="card-post__author-name">
                                                {app.name}
                                                </span>
                                                <small className="text-muted">{app.description}</small>
                                            </div>
                                            </div>
                                            <div className="my-auto ml-auto">
                                                <ButtonView to={'/accounts/'+id+'/apps/'+app.id} />
                                                {/* <ButtonEdit to={'/accounts/'+id+'/apps/edit/'+app.id} /> */}
                                            </div>
                                        </Card.Body>
                                        </Card>
                                    ):("");
                            }) :
                                <NoData/>
                            }
                            </ListGroupItem>
                        </ListGroup>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <br/>
            <br/>
        </>)
    }
}


Account.contextTypes = {
    t: PropTypes.func.isRequired
}

export default Account